import axios from "../axios-interceptor.js"
import { errorResponse, successResponse } from "./SpaceServices.js";
import { searchGroupByName, searchUserByEmail } from "./WebServices.js";

let tenantId = localStorage.getItem("tenantId");
const BACKEND_API = process.env.REACT_APP_BACKEND_API;

export const getRoles = async () => {
    let data = [];
    let tenantId = localStorage.getItem("tenantId");

    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/role/${tenantId}`,
            headers: {
                userId: 1,
            },
        })
        let rolesData = response?.data?.result || []
        data = rolesData.map(role => {
            return { ...role, label: role.role, value: role.role }
        })
    }
    catch {

    }
    return data;

}

export const getPermissions = async () => {
    let data = [];
    await axios({
        method: "GET",
        url: `${BACKEND_API}/entitlements`,
        headers: {
            userId: 1,
        },
    })
        .then((response) => {
            let permissions = response.data?.result
            if (permissions.length > 0) {
                data = permissions.map((entitlement, index) => {
                    return { ...entitlement, key: index }
                })
            }
        })
        .catch((error) => {
        });
    return data;

}

// Users APIS
export const getUsers = async (page, size) => {
    let data = { users: [], totalCount: 0 }

    try {
        const hasPagination = page !== undefined && size !== undefined
        const url = hasPagination
            ? `${BACKEND_API}/users?page=${page}&size=${size}`
            : `${BACKEND_API}/users`
        let response = await axios({
            method: "GET",
            url,
            headers: {
                tenantId: tenantId,
            },
        })
        const result = response?.data?.result
        if (Array.isArray(result)) {
            data.users = result
            data.totalCount = response?.data?.totalCount ?? response?.data?.totalElements ?? result.length
        } else {
            data.users = result?.content ?? result?.users ?? []
            data.totalCount = result?.totalElements ?? result?.totalCount ?? data.users.length
        }
    }
    catch {

    }
    return data
}

const normalizeSearchList = (data) => {
    if (Array.isArray(data)) return data
    if (Array.isArray(data?.result)) return data.result
    if (Array.isArray(data?.items)) return data.items
    if (Array.isArray(data?.content)) return data.content
    return []
}

export const searchUsers = async (query, signal) => {
    const results = await searchUserByEmail(query, signal)
    return normalizeSearchList(results)
}

export const searchGroups = async (query, signal) => {
    const results = await searchGroupByName(query, signal)
    return normalizeSearchList(results)
}

// delete user

export const deleteUser = async (userId) => {
    let data = []

    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/user/${userId}`,
            headers: {
                tenantId: tenantId,
            },
        })
        data = response?.data?.result || []
    }
    catch {

    }
    return data
}

// Create User
export const createUser = async (postData) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: postData.userId ? "PUT" : "POST",
            url: postData.userId ? `${BACKEND_API}/users` : `${BACKEND_API}/user`,
            data: { ...postData },
            headers: {
                tenantId: tenantId,
            },

        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}
export const updateUser = async (postData) => {
    let responseObj = { status: "", message: "", data: {} }

    try {
        let response = await axios({
            method: "PUT",
            url: `${BACKEND_API}/users`,
            data: { ...postData },
            headers: {
                tenantId: tenantId,
            },

        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const uploadProfilePicture = async (file, userId) => {
    let responseObj = { status: "", message: "", data: {} }

    const formData = new FormData();
    formData.append('image', file);

    try {
        let response = await axios({
            method: "POST",
            url: `${BACKEND_API}/image/${userId}?isPfP=true&isCompanyLogo=false`,
            data: formData,
            headers: {
                tenantId: tenantId,
            },

        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

// Fetch Profile Picture (blob)
export const getUserProfileImage = async (userId, fileName) => {
    try {
        const res = await axios({
            method: "GET",
            url: `${BACKEND_API}/image/${userId}/${encodeURIComponent(fileName)}?isPfP=true&isCompanyLogo=false`,
            headers: {
                tenantId: tenantId,
                requestTraceId: "",
                requestTimeStamp: "",
            },
        });
        if (res?.status === 200 && res?.data) {
            // Normalize various backend shapes to { fileName, content }
            // Possibilities seen:
            // 1) { result: { fileName, content } }
            // 2) { result: { body: { fileName, content }, headers: {...} } }
            // 3) { body: { fileName, content } }
            // 4) { fileName, content }
            const data = res.data;
            let payload = null;

            if (data?.result?.body?.content) {
                payload = data.result.body; // preferred when wrapped with headers
            } else if (data?.result?.content) {
                payload = data.result;
            } else if (data?.body?.content) {
                payload = data.body;
            } else if (data?.content) {
                payload = data;
            }

            if (payload?.content) return payload; // { fileName, content }
        }
    } catch (err) {
        // swallow and return null for not-found or other errors
    }
    return null;
}

export const getProfilePicture = async (userId) => {
    let responseObj = { status: "", message: "", data: {} }

    try {
        let response = await axios({
            method: "POST",
            // Keep method as in existing flow but align query param name casing
            url: `${BACKEND_API}/image/${userId}?isPfP=true&isCompanyLogo=false`,
            headers: {
                tenantId: tenantId,
            },

        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

// Delete Profile Picture
export const deleteProfilePicture = async (userId, fileName) => {
    let responseObj = { status: "", message: "", data: {} }

    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/image/${userId}/${encodeURIComponent(fileName)}?isPfP=true&isCompanyLogo=false`,
            headers: {
                tenantId: tenantId,
                requestTraceId: "",
                requestTimeStamp: "",
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

// Company Logo Upload
export const uploadCompanyLogo = async (file, userId) => {
    let responseObj = { status: "", message: "", data: {} }

    const formData = new FormData();
    formData.append('image', file);

    try {
        let response = await axios({
            method: "POST",
            url: `${BACKEND_API}/image/${userId}?isPfP=false&isCompanyLogo=true`,
            data: formData,
            headers: {
                tenantId: tenantId,
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

// Get Company Logo
export const getCompanyLogo = async (userId) => {
    let responseObj = { status: "", message: "", data: {} }

    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/image/${userId}?isPfP=false&isCompanyLogo=true`,
            headers: {
                tenantId: tenantId,
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

// Get Company Logo by file name (base64 JSON)
export const getCompanyLogoImage = async (userId, fileName) => {
    try {
        const res = await axios({
            method: "GET",
            url: `${BACKEND_API}/image/${userId}/${encodeURIComponent(fileName)}?isPfP=false&isCompanyLogo=true`,
            headers: {
                tenantId: tenantId,
                requestTraceId: "",
                requestTimeStamp: "",
            },
        });
        if (res?.status === 200 && res?.data) {
            const data = res.data;
            let payload = null;
            if (data?.result?.body?.content) {
                payload = data.result.body;
            } else if (data?.result?.content) {
                payload = data.result;
            } else if (data?.body?.content) {
                payload = data.body;
            } else if (data?.content) {
                payload = data;
            }
            if (payload?.content) return payload; // { fileName, content }
        }
    } catch (err) {
    }
    return null;
}

// Company CRUD
export const getCompanyDetails = async (companyName, userId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const res = await axios({
            method: "GET",
            url: `${BACKEND_API}/company`,
            params: { companyName },
            headers: {
                tenantId: tenantId,
                'X-Request-ID': "",
                requestTimeStamp: "",
                userId: userId,
            },
        });
        if (res.status === 200) {
            responseObj = successResponse(res.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const createCompany = async (postData, userId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const res = await axios({
            method: "POST",
            url: `${BACKEND_API}/company`,
            data: { ...postData },
            headers: {
                tenantId: tenantId,
                'X-Request-ID': "",
                requestTimeStamp: "",
                'Content-Type': 'application/json',
                userId: userId,
            },
        });
        if (res.status === 200) {
            responseObj = successResponse(res.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const updateCompany = async (postData, userId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const res = await axios({
            method: "PUT",
            url: `${BACKEND_API}/company`,
            data: { ...postData },
            headers: {
                tenantId: tenantId,
                'X-Request-ID': "",
                requestTimeStamp: "",
                'Content-Type': 'application/json',
                userId: userId,
            },
        });
        if (res.status === 200) {
            responseObj = successResponse(res.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}
// Delete Company Logo
export const deleteCompanyLogo = async (userId, fileName) => {
    let responseObj = { status: "", message: "", data: {} }

    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/image/${userId}/${encodeURIComponent(fileName)}?isPfP=false&isCompanyLogo=true`,
            headers: {
                tenantId: tenantId,
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const getUsersBySpace = async (spaceId) => {
    let data = []

    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/users?spaceId=${spaceId}&page=1&size=50`,
            headers: {
                tenantId: tenantId,
            },
        })
        data = response?.data?.result || []
    }
    catch {

    }
    return data
}

export async function addUserToSpace(data, userId) {
    let postData = { ...data }

    let responseObj = {}
    try {
        let response = await axios({
            method: "PUT",
            url: `${BACKEND_API}/users`,
            data: { ...postData, tenantId: localStorage.getItem("tenantId") },
            headers: {
                tenantId: tenantId,
                userId: userId
            }
        })
        responseObj = successResponse(response)
        responseObj.status = response.status
        responseObj.message = response.data.message
    } catch {
        responseObj.status = 500;
        responseObj.message = "Failed to add. Please try again"
    }
    return responseObj
}

// GROUP SERVICES
export const createGroup = async (postData, userInfo) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: postData.groupId ? "PUT" : "POST",
            url: `${BACKEND_API}/group`,
            data: { ...postData },
            headers: {
                userId: userInfo.userId,
                tenantId: tenantId
            }
        });
        responseObj = successResponse(response.data, responseObj, false)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj

}

export const getGroupByTenant = async (page, size) => {
    let data = { groups: [], totalCount: 0 }
    let tenantId = localStorage.getItem("tenantId");

    try {
        const hasPagination = page !== undefined && size !== undefined
        const baseUrl = `${BACKEND_API}/group/tenantId/${tenantId}`
        const url = hasPagination ? `${baseUrl}?page=${page}&size=${size}` : baseUrl
        let response = await axios({
            method: "GET",
            url
        });
        const result = response?.data?.result
        if (Array.isArray(result)) {
            data.groups = result
            data.totalCount = response?.data?.totalCount ?? response?.data?.totalElements ?? result.length
        } else {
            data.groups = result?.content ?? result?.groups ?? []
            data.totalCount = result?.totalElements ?? result?.totalCount ?? data.groups.length
        }
    }
    catch (err) {

    }
    return data

}

export const deleteGroupByTenant = async (groupId) => {
    let data = []
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/group/${groupId}`,
            headers: {
                tenantId: tenantId
            }
        });
        data = response?.data?.result || []
    }
    catch (err) {

    }
    return data

}

// ROLE SERVICES
export const createRole = async (postData, userInfo) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: postData.roleId ? "PUT" : "POST",
            url: `${BACKEND_API}/role`,
            data: { ...postData },
            headers: {
                userId: userInfo.userId,
                tenantId: tenantId
            }
        });
        responseObj = successResponse(response.data, responseObj, false, response.status)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj

}

//DELETE ROLE SERVICES
export const deleteRole = async (postData) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/role/${tenantId}?roleId=${postData.roleId}`,
        });
        responseObj = successResponse(response.data, responseObj, false, response.status)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj

}

// MASTER DATA SERVICES
export const createDatabase = async (postData, update = false) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: update ? "PUT" : "POST",
            url: `${BACKEND_API}/master-data`,
            data: postData,
            headers: {
                tenantId: tenantId
            }
        });
        responseObj = successResponse(response.data, responseObj, false, response.status)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj

}

// Share the new store locations found for a request with recipients via email.
export const sendNewStoreLocationsEmail = async (requestId, emails = []) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "POST",
            url: `${BACKEND_API}/email/new-locations`,
            data: { requestId, emails },
            headers: {
                tenantId: localStorage.getItem("tenantId"),
                'Content-Type': 'application/json',
            }
        });
        responseObj = successResponse(response.data, responseObj, false, response.status)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const getMasterList = async () => {
    let responseObj = { status: "", message: "", data: {} }
    // Re-fetch tenantId in case it was set after module load
    const currentTenantId = localStorage.getItem("tenantId");
    try {
        if (!currentTenantId) {
            return { status: 400, message: "Tenant ID not available", data: [] };
        }
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/master-data/list?tenantId=${currentTenantId}`
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, true)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, true)
    }
    return responseObj
}

export const getSingleMasterData = async (tableId, dataName) => {
    let responseObj = { status: "", message: "", data: {} }

    // Validate parameters before making API call
    if ((!tableId || tableId === 'undefined') && (!dataName || dataName === 'undefined')) {
        return { status: 400, message: "Invalid parameters", data: {} };
    }

    // let url = `${BACKEND_API}/master-data/${tableId}?tenantId=${tenantId}`
    let url = `${BACKEND_API}/master-data`
    if (tableId && tableId !== 'undefined') {
        url += "?dataId=" + tableId
    }
    if (dataName && dataName !== 'undefined') {
        url += (url.includes('?') ? '&' : '?') + "dataName=" + dataName
    }
    try {
        let response = await axios({
            method: "GET",
            url: url,
            headers: {
                tenantId: tenantId
            }
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const getRateMaster = async () => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/rate-master`,
            headers: {
                tenantId: tenantId
            }
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const saveRateMaster = async (postData, update = false) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: update ? "PUT" : "POST",
            url: `${BACKEND_API}/rate-master`,
            data: postData,
            headers: {
                tenantId: tenantId
            }
        });
        responseObj = successResponse(response.data, responseObj, false, response.status)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj

}

export const getAffectedSpaces = async (dataId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/master-data/usage?dataId=${dataId}`,
            headers: {
                tenantId: tenantId
            }
        });
        responseObj = successResponse(response.data, responseObj, false)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const deleteMasterData = async (dataId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/master-data?dataId=${dataId}`,
            headers: {
                tenantId: tenantId
            }
        });
        responseObj = successResponse(response.data, responseObj, false)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const deleteMasterDataRecord = async (dataId, fieldId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/master-data?fieldId=${fieldId}&dataId=${dataId}`,
            headers: {
                tenantId: tenantId
            }
        });
        responseObj = successResponse(response.data, responseObj, false)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const downloadTemplate = async (dataId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/master-data/template?dataId=${dataId}`,
            headers: {
                tenantId: tenantId
            }
        });

        responseObj = { status: response.status, data: response.data }
        // responseObj = successResponse(response.data, responseObj, false)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

export const uploadTemplate = async (dataId, formData) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "POST",
            url: `${BACKEND_API}/master-data/upload?dataId=${dataId}`,
            headers: {
                tenantId: tenantId
            },
            data: formData
        });
        responseObj = successResponse(response.data, responseObj, false, response.status)
    }
    catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj
}

// COMPANY DOMAINS SERVICES
export const getCompanyDomains = async () => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/company-domains`,
            headers: {
                tenantId: localStorage.getItem("tenantId"),
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const updateCompanyDomains = async (companyDomains) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "PUT",
            url: `${BACKEND_API}/company-domains`,
            data: { companyDomains },
            headers: {
                tenantId: localStorage.getItem("tenantId"),
                'Content-Type': 'application/json',
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const deleteCompanyDomains = async (companyDomains) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/company-domains`,
            data: { companyDomains },
            headers: {
                tenantId: localStorage.getItem("tenantId"),
                'Content-Type': 'application/json',
            },
        });
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const getAdminDashboardCounts = async () => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const res = await axios({
            method: "GET",
            url: `${BACKEND_API}/admin/dashboard/all-count`
        });
        if (res.status === 200) {
            responseObj = successResponse(res.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const getAdminDashboardAnalysis = async (params) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const res = await axios({
            method: "GET",
            url: `${BACKEND_API}/admin/dashboard/request-analysis`,
            params: params
        });
        if (res.status === 200) {
            responseObj = successResponse(res.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const requestPlanChange = async (remark) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const res = await axios({
            method: "POST",
            url: `${BACKEND_API}/change-plan`,
            data: {
                request: "pending",
                remark: remark
            },
            headers: {
                tenantId: localStorage.getItem("tenantId"),
                'Content-Type': 'application/json',
            },
        });
        if (res.status === 200) {
            responseObj = successResponse(res.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const connectOutlook = async (tenantIdParam, profileIdParam) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const tenantId = tenantIdParam || localStorage.getItem("tenantId") || "";
        const profileId = profileIdParam || localStorage.getItem("userId") || localStorage.getItem("id") || "";
        const params = new URLSearchParams();
        if (tenantId) params.set("tenantId", tenantId);
        if (profileId) {
            params.set("X-User-ProfileId", profileId);
            params.set("userProfileId", profileId);
        }

        const url = `${BACKEND_API}/oauth/outlook/login${params.toString() ? `?${params.toString()}` : ""}`;
        window.location.href = url;

        responseObj = { status: 200, message: "Redirecting to Outlook login", data: {} }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const getOutlookLoginDetails = async () => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const tenantId = localStorage.getItem("tenantId") || "";
        const profileId = localStorage.getItem("userId") || localStorage.getItem("id") || "";

        const res = await axios({
            method: "GET",
            url: `${BACKEND_API}/oauth/outlook/login/details`,
            headers: {
                tenantId,
                "X-User-ProfileId": profileId,
            },
        });

        responseObj = {
            status: res?.data?.status || res.status,
            message: "",
            data: typeof res?.data?.result === "undefined" ? false : res?.data?.result,
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const disconnectOutlook = async () => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const res = await axios({
            method: "POST",
            url: `${BACKEND_API}/oauth/outlook/disconnect`,
            headers: {
                tenantId: localStorage.getItem("tenantId"),
            }
        });
        if (res.status === 200) {
            responseObj = successResponse(res.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const getUserGroupDeletionImpact = async (email, type = "user", userInfo) => {
  let result = {};
  let url = `${BACKEND_API}/user-deletion-impact/${email}`
  if (type === "group") {
    url = `${BACKEND_API}/group-deletion-impact/${email}`
  }
  try {
    let response = await axios({
      method: "GET",
      url: url,
      headers: {
        userId: userInfo.userId,
      },
    })
    if (response.status === 200) {
      result = response
    }
  }
  catch {

  }
  return result
}

export const getSpacesWidgetInformation = async (email, type = "user", userInfo) => {
  let result = {};
  let url = `${BACKEND_API}/space-information/widgets/${email}?type=${type}`

  try {
    let response = await axios({
      method: "GET",
      url: url,
      headers: {
        userId: userInfo.userId,
      },
    })
    if (response.status === 200) {
      result = response
    }
  }
  catch {

  }
  return result
}

export const getSpacesConditionInformation = async (email, type = "user", userInfo) => {
  let result = {};
  let url = `${BACKEND_API}/space-information/conditions/${email}?type=${type}`

  try {
    let response = await axios({
      method: "GET",
      url: url,
      headers: {
        userId: userInfo.userId,
      },
    })
    if (response.status === 200) {
      result = response
    }
  }
  catch {

  }
  return result
}

export const getSpacesApproversNotifiedUsers = async (email, type = "user", userInfo) => {
  let result = {};
  let url = `${BACKEND_API}/space-information/approver-notify-user/${email}?type=${type}`

  try {
    let response = await axios({
      method: "GET",
      url: url,
      headers: {
        userId: userInfo.userId,
      },
    })
    if (response.status === 200) {
      result = response
    }
  }
  catch {
  }
  return result
}

export const saveActivityConfig = async (postData) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        const res = await axios({
            method: "POST",
            url: `${BACKEND_API}/reporting/save`,
            data: { data: postData },
            headers: {
                tenantId: localStorage.getItem("tenantId"),
            }
        });
        if (res.status === 200) {
            responseObj = successResponse(res.data, responseObj, false)
        }
    } catch (err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const getActivityConfig = async (userInfo) => {
  let result = {};
  let url = `${BACKEND_API}/reporting/config`

  try {
    let response = await axios({
      method: "GET",
      url: url,
      headers: {
        userId: userInfo.userId,
      },
    })
    if (response.status === 200) {
      result = response
    }
  }
  catch {

  }
  return result
}

export const getActivityLogs = async (userInfo, page, size) => {
  let result = {};
  let url = `${BACKEND_API}/reporting/fetch`
  if (page !== undefined && size !== undefined) {
    url = `${url}?page=${page}&size=${size}`
  }

  try {
    let response = await axios({
      method: "GET",
      url: url,
      headers: {
        userId: userInfo.userId,
      },
    })
    if (response.status === 200) {
      result = response
    }
  }
  catch {

  }
  return result
}

export const getActivityFilters = async (params, userInfo, page, size) => {
  let result = {};
  let url = `${BACKEND_API}/reporting/filters`
  if (page !== undefined && size !== undefined) {
    url = `${url}?page=${page}&size=${size}`
  }

  try {
    let response = await axios({
      method: "POST",
      url: url,
      headers: {
        userId: userInfo.userId,
      },
      data: params
    })
    if (response.status === 200) {
      result = response
    }
  }
  catch {

  }
  return result
}